import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'export-button-renderer',
  template: 
  `
  <button mat-button color="primary" type="button" (click)="onClick($event)" [disabled]="params.data.Status =='Processing' || params.data.Status =='Submitted'">
  <mat-icon>get_app</mat-icon>
  </button>
  &nbsp;
  <button mat-button style="color: red" type="button" (click)="onDeleteClick($event)">
  <mat-icon>delete</mat-icon>
  </button>
  `,
  styles:[`
   `]

})
export class ExportButtonRendererComponent implements ICellRendererAngularComp {
 
params;

  agInit(params): void {
    this.params = params;
   // console.log("params",this.params);
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.onClick(params);
    }
  }

  refresh(params?: any): boolean {
    return true;
  }

  onDeleteClick($event) {
    if (this.params.onDeleteClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.onDeleteClick(params);
    }
  }
}
